const LightThemeColor = "#FFFFFF";
const LightThemeLabels = "#30424F";
const DarkThemeColor = "#30424F";
const DarkThemeLabels = "#FFFFFF";

const DarkColumnColors: string[] = ["#30424F"];
const AshColumnColors: string[] = ["#838E96"];
const BlueColumnColors: string[] = ["#4E64CA"];
const RubyColumnColors: string[] = ["#DE2C67"];
const GreenColumnColors: string[] = ["#24827F"];
const LilacColumnColors: string[] = ["#9B29BD"];
const MustardColumnColors: string[] = ["#AD6600"];
const BorderRadius = 10;

const QualitativeColors: string[] = ["#5B74F0", "#B442D6", "#EB1562", "#24827F", "#D47F00", "#4E64CA",
    "#D18CE6", "#38A19D", "#FFC266", "#F373A1", "#9AAAF6", "#34C0BC", "#FF4895", "#E775FF", "#67F3EF", 
    "#AB6600", "#FFAEFB", "#BEFF97", "#FF7BC8", "#BED8FF", "#FFCC66", "#FFDBFF", "#8BD964", "#D20049", "#FCB6B5"];

const LightThemeCommonOptions: Highcharts.Options = {
    chart: {
        backgroundColor: LightThemeColor,
        borderRadius: BorderRadius
    }
}

const DarkThemeCommonOptions: Highcharts.Options = {
    chart: {
        backgroundColor: DarkThemeColor,
        borderRadius: BorderRadius
    }
}

export const greyTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: DarkColumnColors
}

export const multiGreyTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#9EA3B2", "#B6BCC8", "#CDD4DD", "#E5EDF3"]
}

export const ashTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: AshColumnColors
};

export const multiAshTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#515665", "#737887", "#959AA9", "#B7BCCB"]
}

export const defaultTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: QualitativeColors
}

export const darkTheme: Highcharts.Options = {
    ...DarkThemeCommonOptions,
    colors: QualitativeColors
}

export const rubyTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: RubyColumnColors
}

export const multiRubyTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#EB1562", "#F23784", "#F859A6", "#FF7BC8"]
}

export const blueTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: BlueColumnColors
}

export const multiBlueTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#4E64CA", "#7086DC", "#92A8ED", "#B4CAFF"]
}

export const mustardTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: MustardColumnColors
}

export const multiMustardTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#D47F00", "#E2A122", "#F1C344", "#FFE566"]
}

export const greenTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: GreenColumnColors
}

export const multiGreenTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#24827F", "#46A4A1", "#68C6C3", "#8AE8E5"]
}

export const lilacTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: LilacColumnColors
}

export const multiLilacTheme: Highcharts.Options = {
    ...LightThemeCommonOptions,
    colors: ["#B442D6", "#CD64E4", "#E686F1", "#FFA8FF"]
}

export const colorThemes = {
    0: defaultTheme,
    1: ashTheme,
    2: greyTheme,
    3: darkTheme,
    4: rubyTheme,
    5: blueTheme,
    6: mustardTheme,
    7: greenTheme,
    8: lilacTheme
}

export const multiColorThemes = {
    0: defaultTheme,
    1: multiAshTheme,
    2: multiGreyTheme,
    3: darkTheme,
    4: multiRubyTheme,
    5: multiBlueTheme,
    6: multiMustardTheme,
    7: multiGreenTheme,
    8: multiLilacTheme
}